import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { RequestSettingsDialogComponent } from './request-settings-dialog.component';
import { CategoryFormModule } from './components/category-form/category-form.module';
import { CategoryListModule } from './components/category-list/category-list.module';
import { DepartmentListModule } from './components/department-list/department-list.module';
import { DepartmentFormModule } from './components/department-form/department-form.module';
import { StatusListModule } from './components/status-list/status-list.module';
import { StatusFormModule } from './components/status-form/status-form.module';
import { SettingsHeaderModule } from './components/settings-header/settings-header.module';
import { SettingsFooterModule } from './components/settings-footer/settings-footer.module';
import { CreateSubjectDialogModule } from './components/create-subject-dialog/create-subject-dialog.module';
import { SharedModule } from '../shared/shared.module';
import { OtherSettingsModule } from './components/other-settings/other-settings.module';

@NgModule({
    declarations: [RequestSettingsDialogComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        TranslateModule,
        CategoryFormModule,
        CategoryListModule,
        DepartmentListModule,
        DepartmentFormModule,
        StatusListModule,
        StatusFormModule,
        OtherSettingsModule,
        SettingsHeaderModule,
        SettingsFooterModule,
        MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        CreateSubjectDialogModule,
        SharedModule,
    ],
    exports: [RequestSettingsDialogComponent],
})
export class RequestSettingsDialogModule {}
